import React, { useState, useEffect, useRef } from "react";
import * as Mui from "@mui/material";
import { showToast } from "services/utils/Status";
import { checkEditorPermission } from "services/utils/HelperFunction";
import { RemoveRedEye } from "@mui/icons-material";
import { themes, scrollTop, optionalAvathar } from "services/constants";
import { useSelector } from "react-redux";
import { useFetch } from "services/hooks/useFetch";
import { userShiftGradeHeader } from "pages/Administration/AdministrationHeaders";
import { Loader } from "components/Loader";
import { InfoMessage } from "components/CustomComponents/CustomButton";

export const ShiftGrade = ({
  setIsViewPanelOpen,
  setUserData,
  userShiftGradeDetails,
  setUserShiftGradeDetails,
  trigger,
  setTrigger,
  setGradeData,
  page,
  setPage,
}) => {
  const { domain, globalSearchValue, userScreenAccess } = useSelector(
    (state) => state.tokenReducer
  );
  const [rowsPerPage, setRowsPerPage] = useState(25);
  let check_access = checkEditorPermission(
    userScreenAccess?.module_details,
    "Shift",
    "Employee Shift Grade"
  );
  const { result: userShiftGradeData, loading: userShiftGradeLoading } =
    useFetch(
      `${domain}administration/shiftroster/userassignment/shiftgrade/shift-grade-details/`
    );

  const containerRef = useRef(null);
  const sortedShiftCategoryData = userShiftGradeData?.data
    ?.slice()
    .sort((a, b) => {
      const dateA = new Date(a.effective_from);
      const dateB = new Date(b.effective_from);
      if (dateA < dateB) return 1;
      if (dateA > dateB) return -1;
      const assignNameA = a.employee_name || "";
      const assignNameB = b.employee_name || "";
      return assignNameA.localeCompare(assignNameB, undefined, {
        numeric: true,
      });
    });

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    if (
      (sortedShiftCategoryData?.length !== 0 ||
        sortedShiftCategoryData?.length === 0) &&
      trigger &&
      sortedShiftCategoryData
    ) {
      setUserShiftGradeDetails(sortedShiftCategoryData);
      setGradeData(sortedShiftCategoryData);
      setTrigger(false);
    }
  }, [
    globalSearchValue,
    page,
    setGradeData,
    setTrigger,
    setUserShiftGradeDetails,
    sortedShiftCategoryData,
    trigger,
  ]);

  useEffect(() => {
    scrollTop(containerRef);
  }, [page]);

  return userShiftGradeLoading ? (
    <Loader />
  ) : (
    <React.Fragment>
      <React.Fragment>
        <Mui.Grid
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            mr: 2,
          }}
        >
          <Mui.Typography sx={{ fontWeight: 600 }}>
            Total Number of Employee :{" "}
            {userShiftGradeDetails
              ? new Set(userShiftGradeDetails.map((item) => item.user_id)).size
              : 0}
          </Mui.Typography>
        </Mui.Grid>

        <Mui.TableContainer
          ref={containerRef}
          sx={{
            mt: 2,
            paddingRight: 2,
            width: "100%",
            ml: 2,
            mr: 2,
            maxHeight: 520,
          }}
          id="Shift_grade_table"
        >
          <Mui.Table className="border">
            <Mui.TableHead
              sx={{
                backgroundColor: themes.primary,
                position: "sticky",
                top: -1,
                zIndex: 10,
              }}
            >
              <Mui.TableRow
                sx={{
                  "& .MuiTableCell-root": {
                    height: "10px",
                    padding: "3px 15px",
                  },
                }}
              >
                {userShiftGradeHeader?.map((head) => (
                  <Mui.TableCell
                    sx={{ color: themes.headLine, fontWeight: "bold" }}
                  >
                    {head.name}
                  </Mui.TableCell>
                ))}
              </Mui.TableRow>
            </Mui.TableHead>
            <Mui.TableBody>
              {userShiftGradeDetails?.length === 0 && !userShiftGradeLoading ? (
                <InfoMessage dataLength={sortedShiftCategoryData} />
              ) : (
                userShiftGradeDetails
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  ?.map((shift_group_users) => (
                    <React.Fragment>
                      <Mui.TableRow
                        sx={{
                          "& .MuiTableCell-root": {
                            height: "10px",
                            padding: "3px 15px",
                          },
                        }}
                      >
                        {userShiftGradeHeader?.map((head) =>
                          head.name === "Actions" ? (
                            <Mui.TableCell>
                              <Mui.Stack direction="row">
                                <Mui.IconButton
                                  onClick={() => {
                                    if (check_access) {
                                      setIsViewPanelOpen(true);
                                      setUserData(shift_group_users);
                                    } else {
                                      showToast(
                                        "error",
                                        `Access denied: You are not authorized to move shift grade`
                                      );
                                    }
                                  }}
                                >
                                  <RemoveRedEye
                                    sx={{
                                      cursor: "pointer",
                                      color: themes?.mutedgreen,
                                    }}
                                  />
                                </Mui.IconButton>
                              </Mui.Stack>
                            </Mui.TableCell>
                          ) : (
                            <Mui.TableCell>
                              {head.key === "effective_from" ||
                              head.key === "effective_to" ? (
                                shift_group_users[head.key] ? (
                                  shift_group_users[head.key]
                                ) : (
                                  "N/A"
                                )
                              ) : head?.key === "employee_name" ? (
                                <Mui.Stack direction="Row">
                                  <Mui.Avatar
                                    sx={{ width: 23, height: 23 }}
                                    alt={shift_group_users?.employee_name
                                      ?.charAt(0)
                                      .toUpperCase()}
                                    src={
                                      shift_group_users?.image_url ??
                                      optionalAvathar
                                    }
                                  />
                                  &nbsp;
                                  {shift_group_users?.employee_name}
                                </Mui.Stack>
                              ) : shift_group_users[head.key] ? (
                                shift_group_users[head.key]
                              ) : (
                                "N/A"
                              )}
                            </Mui.TableCell>
                          )
                        )}
                      </Mui.TableRow>
                    </React.Fragment>
                  ))
              )}
            </Mui.TableBody>
          </Mui.Table>
        </Mui.TableContainer>
        {userShiftGradeDetails?.length > 25 && (
          <Mui.Box sx={{ mt: 1 }}>
            <Mui.TablePagination
              className="custom-pagination"
              component="div"
              rowsPerPageOptions={[25, 50, 75, 100]}
              count={userShiftGradeDetails?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Mui.Box>
        )}
      </React.Fragment>
    </React.Fragment>
  );
};
